
import firebase from "./auth"
import React, { Component } from 'react'


class SignIn extends Component {

    constructor(props){
        super(props);

        this.state = {
            password: "",
            email: "",
            errorMSG: null
        }
    }

    submit(e){
        e.preventDefault();

        firebase.auth().signInWithEmailAndPassword(this.state.email, this.state.password)
        .then((user) => {
            
        })
        .catch((error) => {
            var errorCode = error.code;
            var errorMessage = error.message;
            this.setState({
                errorMSG: "Anmeldedaten falsch. Bitte kontaktieren Sie uns"
            }) 
        });
    }





    render() {

        return (
            <div style={{
 
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: 'auto',
                flexDirection: 'column',
                height: '100vh'
            }}>
                
                <form className="submissionForm" style={{
                maxWidth: 996,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: 'auto',
                flexDirection: 'column',
                height: '100%'
            }}>
                <h3 style={{color: '#fff'}}>Bitte Anmelden</h3>
                    <input type="email" placeholder="Email" value={this.state.email} onChange={
                        (e) => {
                            this.setState({email:e.target.value})
                        }
                    }/>
                    <input type="password" placeholder="Password" value={this.state.password} onChange={
                        (e) => {
                            this.setState({password:e.target.value})
                        }
                    } required/>
                        <button onClick={(e)=>{this.submit(e)}}>Anmelden</button>

                    {this.state.errorMSG && <div className="err_msg">
                        {this.state.errorMSG}    
                    </div>}

                    {this.props.message && <div className="err_msg">
                        {this.props.message}    
                    </div>}
                </form>
            </div>
        )
    }
}

export default SignIn
